import { Box, DialogContent, DialogTitle } from '@mui/material';
// Full-screen print layout, not a bottom-sheet dialog — stays on MUI.
import MuiDialog from '@mui/material/Dialog';
import { useEffect, useState } from 'react';
import { GoogleMap, useGoogleMap } from '@react-google-maps/api';
import chabadLogo from '../../../../assets/logo-1-e1692812137779.png';
import { useFetch } from '@/hooks/useFetch';
import { editGeomUrl } from '@/constants';
import { Input } from '@sm-dashboard/ui-components';

const MapPrint = ({
  polygons,
  handleClose
}: {
  polygons: google.maps.Polygon[] | undefined;
  handleClose: () => void;
}) => {
  const [zoomMap, setZoomMap] = useState({ zoon: 10, center: { lat: 31.794431983241022, lng: 35.18878195954886 } });

  const containerStyle = {
    height: '350px',
    width: '100%',
    borderRadius: '0px 0px 8px 8px'
  };

  useEffect(() => {
    setTimeout(() => {
      window.print();
    }, 700);
  }, []);
  return (
    <MuiDialog sx={{ textAlign: 'center', position: 'relative' }} onClose={() => null} open={true} fullScreen>
      <DialogTitle>מפת שליחות חתומה</DialogTitle>
      <Box
        component="img"
        alt="logo."
        width={135}
        src={chabadLogo}
        sx={{ position: 'absolute', left: '50px', top: '0px' }}
      />
      <DialogContent
        sx={{
          gap: 2,
          display: 'flex',
          flexDirection: 'column',
          width: '80%',
          alignItems: 'center',
          justifyContent: 'center',
          margin: 'auto'
        }}
      >
        <Input appearance='plain' label="שם השליח המאשר" />
        <Input appearance='plain' label="שם הסניף" />

        <Input appearance='plain' label="שם השליח" />
        <Input appearance='plain' label="סוג התיחום" />

        <Input appearance='plain' label="פירוט התיחום במילים (שמות רחובות)" multiline rows={6} />

        <Input appearance='plain' label="הערות" multiline rows={2} />

        <GoogleMap zoom={zoomMap.zoon} center={zoomMap.center} mapContainerStyle={containerStyle}>
          <PolygonBounds polygons={polygons} handleClose={handleClose} />
        </GoogleMap>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', p: 2 }}>
          <Input appearance='plain' label="תאריך" />
          <Input appearance='plain' label="חתימת שליח המאשר + חותמת" />
        </Box>
      </DialogContent>
    </MuiDialog>
  );
};

export default MapPrint;

const PolygonBounds = ({
  polygons,
  handleClose
}: {
  polygons: google.maps.Polygon[] | undefined;
  handleClose: () => void;
}) => {
  const { fetchData } = useFetch();

  const map = useGoogleMap();

  useEffect(() => {
    if (polygons && map) {
      const bounds = new google.maps.LatLngBounds();
      polygons.forEach((polygon, index) => {
        polygon.setMap(map);
        polygon.getPath().forEach(path => {
          bounds.extend(path);
        });
      });
      map.fitBounds(bounds);

      setTimeout(() => {
        fetchData({
          method: 'POST',
          url: editGeomUrl,
          data: {
            requestType: 1,
            branchType: 1,
            branchName: 'string',
            comment: 'string',
            coordinates: polygons.map(poly =>
              poly
                .getPaths()
                .getArray()[0]
                .getArray()
                .map(path => {
                  return [path.lng(), path.lat()];
                })
            )
          }
        });
        handleClose();
      }, 1000);
    }
  }, [polygons, map]);

  return <></>;
};
